import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { Link } from "react-router-dom";

import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import logoLightPng from "../../assets/images/logo-light.png";
import logoLightSm from "../../assets/images/logo-sm-light.png";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <div className="vertical-menu">
          <div className="navbar-brand-box">
            <Link to="/" className="logo logo-light">
              <span className="logo-sm">
                <img src={logoLightSm} alt="" height="22" />
              </span>
              <span className="logo-lg">
                <img src={logoLightPng} alt="" height="24" />
              </span>
            </Link>
          </div>
          <div data-simplebar className="h-100">
            <SidebarContent />
          </div>
          <div className="sidebar-background"></div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(withTranslation()(Sidebar));
